import React, { useContext, useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { AdminContext } from '../../context/AdminContext'
import Api from '../../api'
import MessageTypes from '../ActiveChatInfo/MessageTypes'
import Avatar from '../Avatar'
import FileTypesContainer from '../FileTypesContainer'
import Loader from '../Loader'
import MessageDateSeen from '../MessageDateSeeen'
import RepliedMessage from '../OnlineChat/RepliedMessage'
import isMobileTablet from '../../functions/IsMobileTablet'
import BrowserDetection from '../../functions/BrowserDetection'
import styles from '../OnlineChat/styles.module.scss';
import FileSection from '../FileSection'
import style from './styles.module.css';

// import Api from '../api'

export default function FavContent(props) {
    const {activeUser, themeMode,language,direction}= useContext(AdminContext)
    const [list,setList]= useState([])
    const [loading,setloading]= useState(true)
    const [count,setCount]= useState(0)
    const [hasMore, setHasMore] = useState(false);
    const [scrollNow, setScrollNow] = useState('');
    const [activePlayer, setActivePlayer] = useState();
    const lastMessage=useRef(null)

    
    // const findList=(params)=>{
    //     Api.favList(activeUser?.id,{params:params})
    //         .then((res)=>{
    //             if (params.start == 0){
    //                 setList(res.data.response)
    //             }else{
    //                 const newarray = list.concat(res?.data?.response);
    //                 setList(newarray)
    //                 setCount(res?.data?.response_details?.count)
    //             }

    //             lastMessage.current?.scrollIntoView({ behavior: 'smooth' });
    //             setloading(false);
    //         })
    //         .catch((err)=>{
    //             setloading(false);
    //         })
    // }
    // useEffect(()=>{
    //     let params={start:0, limit:10}
    //     findList(params)
    // },[])
    // const getMorePosts=()=>{
    //     let params={start:list?.length, limit:10}
    //     findList(params)
    // }

    // useEffect(() => {
    //     setHasMore(list.length < count);
    
    //     if (list.length == 0) {
    //       setHasMore(false);
    //     }
    //   }, [list, count]);
    // console.log("favlist", list)
  return (
    <FileSection
    content={props?.content}
    extraScrollDivStyle={style.scrollDivOuter}
    extraScrollDivStyleInside={style.scrollDivInside}
    favorite={true}
    messages={props?.messages}
    setMessages={props?.setMessages}
  />
  )
}
